import { type PropType } from 'vue';
import {
    UPDATE_MODEL_VALUE,
    type ComponentSizes, componentSizeProp,
    type ComponentView, componentViewProp,
    type ClearableType, clearableProp,
} from '../../constants';
import { chipProps, type ChipProps } from '../chip/chip';

export interface InputProps extends ChipProps {
    modelValue: string | string[];
    size?: ComponentSizes;
    disabled?: boolean;
    readonly?: boolean;
    loading?: boolean;
    clearable?: ClearableType;
    view?: ComponentView;
    type?: string;
    placeholder?: string;
    label?: string;
    maxLength?: string | number;
    minLength?: string | number;
    multiple?: boolean;
    max?: number;
    addTrigger?: 'Enter' | 'Space';
}

export const inputProps = {
    modelValue: {
        type: [String, Array] as PropType<string | string[]>,
        default: undefined,
        required: true,
    },
    size: componentSizeProp,
    disabled: {
        type: Boolean as PropType<InputProps['disabled']>,
        default: undefined,
        required: false,
    },
    readonly: {
        type: Boolean as PropType<InputProps['readonly']>,
        default: undefined,
        required: false,
    },
    loading: {
        type: Boolean as PropType<InputProps['loading']>,
        default: undefined,
        required: false,
    },
    clearable: clearableProp,
    view: componentViewProp,
    type: {
        type: String as PropType<InputProps['type']>,
        default: 'text',
        required: false,
    },
    placeholder: {
        type: String as PropType<InputProps['placeholder']>,
        default: undefined,
        required: false,
    },
    label: {
        type: String as PropType<InputProps['label']>,
        default: undefined,
        required: false,
    },
    maxLength: {
        type: [String, Number] as PropType<InputProps['maxLength']>,
        default: undefined,
        required: false,
    },
    minLength: {
        type: [String, Number] as PropType<InputProps['minLength']>,
        default: undefined,
        required: false,
    },
    multiple: {
        type: Boolean as PropType<InputProps['multiple']>,
        default: undefined,
        required: false,
    },
    max: {
        type: Number as PropType<InputProps['max']>,
        default: undefined,
        required: false,
    },
    addTrigger: {
        type: String as PropType<InputProps['addTrigger']>,
        default: 'Enter',
        required: false,
    },
    ...chipProps,
};

export const inputEmits = {
    [UPDATE_MODEL_VALUE]: (event: string | string[]) => event,
    change: (event: string) => event,
    focus: (event: string) => event,
    clear: (event: string | string[]) => event,
    blur: (event: string) => event,
    input: (event: string) => event,
};
